import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Programme from "@/components/sections/Programme";
import GamesTeaser from "@/components/sections/GamesTeaser";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import Enrollment from "@/components/sections/Enrollment";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <Programme />
      <GamesTeaser />
      <Gallery />
      <Testimonials />
      <Enrollment />
      <Contact />
    </main>
  );
}
